export default "__VITE_ASSET__BReh3Bw$__"